<div class="abdm-records">
  <header class="page-header">
    <div class="page-heading">
      <h2>{{ 'ABDM.TITLE' | translate }}</h2>
      <p>{{ 'ABDM.SUBTITLE' | translate }}</p>
    </div>
    <div class="header-actions">
      <button mat-icon-button type="button" class="refresh-button" [attr.aria-label]="'ABDM.REFRESH_ARIA' | translate"
        [matTooltip]="'ABDM.REFRESH_TITLE' | translate" [disabled]="loading" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-flat-button type="button" class="request-button" (click)="requestRecords()">
        <mat-icon>add</mat-icon>
        {{ 'ABDM.REQUEST_RECORDS' | translate }}
      </button>
    </div>
  </header>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="consent-section" [attr.aria-label]="'ABDM.CONSENT_REQUESTS' | translate">
    <div class="records-toolbar" *ngIf="consents.length">
      <h3>{{ 'ABDM.CONSENT_REQUESTS' | translate }}</h3>
    </div>

    <div class="empty-state" *ngIf="!consents.length && !loading">
      <mat-icon>assignment</mat-icon>
      <span>{{ 'ABDM.NO_CONSENTS' | translate }}</span>
    </div>

    <div class="table-responsive bg-white rounded border" *ngIf="consents.length">
      <table class="table table-hover w-100 m-0">
        <thead>
          <tr>
            <th class="p-3">{{ 'ABDM.DATA_TYPES_REQUESTED' | translate }}</th>
            <th class="p-3">{{ 'ABDM.VALID_FROM' | translate }}</th>
            <th class="p-3">{{ 'ABDM.VALID_TO' | translate }}</th>
            <th class="p-3">{{ 'ABDM.STATUS_HEADER' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let consent of consents">
            <td class="p-3">
              <div class="f-s-13 text-muted">{{ consent.hiTypes.join(', ') }}</div>
            </td>
            <td class="p-3 f-s-13 text-muted">{{ consent.permissionFrom | commonDate }}</td>
            <td class="p-3 f-s-13 text-muted">{{ consent.permissionTo | commonDate }}</td>
            <td class="p-3 status-cell">
              <div class="status-summary">
                <div class="status-row">
                  <span class="status-label">{{ 'ABDM.CONSENT_STATUS' | translate }}</span>
                  <span class="status-pill m-0" [ngClass]="statusClass(consent.status)">
                    <mat-icon>{{ getStatusIcon(consent.status) }}</mat-icon>
                    {{ statusLabel(consent.status) }}
                  </span>
                </div>
                <div class="error f-s-11 mt-1 text-danger text-center" *ngIf="consent.failureReason">
                  {{ consent.failureReason }}
                </div>
                <ng-container *ngIf="consent.status === 'Granted'">
                  <div class="status-row">
                    <span class="status-label">{{ 'ABDM.RECORD_FETCH_STATUS' | translate }}</span>
                    <span class="status-pill fetch-status-pill m-0"
                      [attr.data-fetch-status]="consent.dataFetchStatus"
                      [ngClass]="statusClass(consent.dataFetchStatus)">
                      <mat-icon>{{ getStatusIcon(consent.dataFetchStatus) }}</mat-icon>
                      {{ statusLabel(consent.dataFetchStatus) }}
                    </span>
                  </div>
                  <div class="error fetch-failure-reason text-danger"
                    *ngIf="consent.dataFetchFailureReason">
                    {{ consent.dataFetchFailureReason }}
                  </div>
                </ng-container>
                <div class="status-actions">
                <button mat-button type="button" class="retry-button p-0 min-width-auto btn-sm mt-1"
                  *ngIf="consent.status === 'Failed' && !consent.consentRequestId"
                  [disabled]="isRecovering(consent.id)" (click)="retry(consent)">
                  {{ 'ABDM.RETRY' | translate }}
                </button>
                <button mat-button type="button" class="retry-button p-0 min-width-auto btn-sm mt-1"
                  *ngIf="canCheckStatus(consent)" [disabled]="isRecovering(consent.id)"
                  (click)="checkConsentStatus(consent)">
                  {{ 'ABDM.CHECK_STATUS' | translate }}
                </button>
                <button mat-button type="button" class="retry-button p-0 min-width-auto btn-sm mt-1"
                  *ngIf="canRetryFetch(consent)" [disabled]="isRecovering(consent.id)"
                  (click)="retryFetch(consent)">
                  {{ 'ABDM.RETRY_RECORDS' | translate }}
                </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="records-section">
    <div class="records-toolbar">
      <h3>{{ 'ABDM.RECEIVED_RECORDS' | translate }}</h3>
      <div class="records-actions" *ngIf="records.length">
        <label class="search-box">
          <mat-icon>search</mat-icon>
          <input type="search" [value]="searchTerm" (input)="updateSearch($event)"
            [placeholder]="'ABDM.SEARCH_PLACEHOLDER' | translate"
            [attr.aria-label]="'ABDM.SEARCH_PLACEHOLDER' | translate">
        </label>
      </div>
    </div>

    <div class="info-banner" *ngIf="pendingFetch && !loading" role="status">
      <mat-icon>hourglass_top</mat-icon>
      <span>{{ 'ABDM.RECORDS_PENDING' | translate }}</span>
    </div>

    <div class="empty-state" *ngIf="!records.length && !loading && !pendingFetch">
      <mat-icon>folder_open</mat-icon>
      <span>{{ 'ABDM.NO_RECORDS' | translate }}</span>
    </div>
    <div class="empty-state" *ngIf="records.length && !filteredRecords.length">
      <mat-icon>search_off</mat-icon>
      <span>{{ 'ABDM.NO_SEARCH_RESULTS' | translate }}</span>
    </div>

    <div class="records-shell" *ngIf="filteredRecords.length">
      <mat-accordion class="records-list" multi>
        <mat-expansion-panel *ngFor="let record of pagedRecords" (opened)="loadDetails(record)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <strong>{{ record.title }}</strong>
            </mat-panel-title>
            <mat-panel-description>
              <span>{{ record.hiType }}</span>
              <span class="record-separator">&middot;</span>
              <span>{{ record.sourceHipId }}</span>
              <span class="record-separator">&middot;</span>
              <span>{{ record.recordDate | commonDate }}</span>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="record-loading" *ngIf="!record.fhirJson && !detailLoadFailures.has(record.id)">
            <mat-spinner diameter="20"></mat-spinner>
            {{ 'ABDM.LOADING_DETAILS' | translate }}
          </div>

          <ng-container *ngIf="clinicalViews.get(record.id) as view">
            <div class="record-overview">
              <div class="overview-item" *ngIf="view.patient">
                <div><span>{{ 'ABDM.PATIENT' | translate }}</span><strong>{{ view.patient }} <small
                      *ngIf="view.patientDetails">({{ view.patientDetails }})</small></strong></div>
              </div>
              <div class="overview-item" *ngIf="view.practitioner">
                <div><span>{{ 'ABDM.CLINICIAN' | translate }}</span><strong>{{ view.practitioner }}</strong></div>
              </div>
              <div class="overview-item" *ngIf="view.organization">
                <div><span>{{ 'ABDM.FACILITY' | translate }}</span><strong>{{ view.organization }}</strong></div>
              </div>
              <div class="overview-item">
                <div>
                  <span>{{ 'ABDM.RECORD_DATE' | translate }}</span>
                  <strong>{{ (view.date | commonDate) || ('ABDM.NOT_PROVIDED' | translate) }}</strong>
                </div>
              </div>
            </div>

            <section class="clinical-group" *ngFor="let group of view.groups">
              <h5>{{ group.title }}</h5>
              <div class="clinical-item" *ngFor="let item of group.items">
                <strong>{{ item.label }}</strong>
                <p>{{ item.value }}</p>
                <small *ngIf="item.detail">{{ item.detail }}</small>
              </div>
            </section>
          </ng-container>

          <div class="record-fallback" *ngIf="detailLoadFailures.has(record.id)">
            <p>{{ 'ABDM.DETAIL_LOAD_FAILED' | translate }}</p>
            <p>{{ parseSummary(record.summary) }}</p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <footer class="records-pagination">
        <span>{{ 'ABDM.SHOWING_RECORDS' | translate:{ from: firstVisibleRecord, to: lastVisibleRecord, total:
          filteredRecords.length } }}</span>
        <nav *ngIf="totalPages > 1" [attr.aria-label]="'ABDM.PAGINATION' | translate">
          <button type="button" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
            [attr.aria-label]="'ABDM.PREVIOUS_PAGE' | translate"><mat-icon>chevron_left</mat-icon></button>
          <button type="button" *ngFor="let page of visiblePages" [class.active]="page === currentPage"
            [attr.aria-current]="page === currentPage ? 'page' : null" (click)="goToPage(page)">{{ page }}</button>
          <button type="button" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
            [attr.aria-label]="'ABDM.NEXT_PAGE' | translate"><mat-icon>chevron_right</mat-icon></button>
        </nav>
      </footer>
    </div>
  </section>
</div>
